export default "__VITE_PUBLIC_ASSET__e06d0193__"